export const POST_REGISTER_USER = (invitacion_code) => `${process.env.REACT_APP_API_INVITATION}/${invitacion_code}`;
export const GET_INFO_USER = (code) => `${process.env.REACT_APP_API_INVITATION}/${code}`;